import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './MissedCallApprovalModal.css';
import TauriImage from '../../../TauriImage/TauriImage';

const MissedCallApprovalModal = ({ show, onHide, item }) => {

    const [approvals, setApprovals] = useState([]);

    useEffect(() => {
        const sampleData = [
            {
                date: "July 31, 2025",
                name: "Capundan, Jeffrey",
                code: "NR-001 Doctor Migrated",
                status: null
            },
            {
                date: "July 31, 2025",
                name: "Ambe, Charold",
                code: "NR-001 Doctor Migrated",
                status: null
            },
            {
                date: "July 31, 2025",
                name: "Caoili, Benedict",
                code: "NR-001 Doctor Migrated",
                status: null
            },
            {
                date: "July 31, 2025",
                name: "Caoili, Benedict",
                code: "NR-001 Doctor Migrated",
                status: null
            },
            {
                date: "July 31, 2025",
                name: "Caoili, Benedict",
                code: "NR-001 Doctor Migrated",
                status: null
            }
        ];
        setApprovals(sampleData);
    }, []);

    return (
        <Modal className='missedcall-approval-modal' show={show} onHide={onHide} size="lg" centered>
            <Modal.Header>
                <div className='header-title'>MISSED CALLS APPROVAL</div>
                <div className="cycle-info">
                    <div className="cycle-title">Cycle 7 - July 1 to 31, 2025</div>
                </div>
                <div className='employee-section'>
                    <div className="employee-card">
                        <div className="employee-avatar flex-shrink-0 me-3 me-md-2 me-lg-3">MS</div>
                        <div className="employee-details">
                            <div className="employee-name">{item?.Name}</div>
                            <div className="employee-location">Paranaque/Alabang/Muntinlupa</div>
                        </div>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body>
                <div className="approvals-list">
                    {approvals.map((a, index) => (
                        <div key={index} className="approval-item">
                            <div className="approval-date">{a.date}</div>
                            <div className="approval-name">{a.name}</div>
                            <div className="approval-code">{a.code}</div>
                            <div className="approval-actions">
                                <Button className="btn-approve d-flex align-items-center">
                                    <TauriImage localImage={"/Images/material-symbols--check.svg"} color={"#FFF"} />
                                    <div>Approve</div>
                                </Button>
                                <Button className="btn-reject d-flex align-items-center">
                                    <TauriImage localImage={"/Images/material-symbols--close.svg"} color={"#FFF"} />
                                    <div>Reject</div>
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MissedCallApprovalModal;
